// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--BEXkw","icon-wrapper":"_9e1425b4d3--icon-wrapper--p7aCT","_clickable":"_9e1425b4d3--_clickable--hrg6e"};